<template>
	<tr :class="isClosed">
		<td class="consulatant-cell">
			<!-- <p class="left-td" v-tooltip.top-start="relation.fullName">{{relation.fullName | truncate}}</p> -->
			<p class="left-td">
				<i v-tooltip.top-start="relation.fullName">{{relation.fullName}}</i>
			</p>
		</td>
		<td class="sap-cell">
			<p class="left-td">
				<i v-tooltip.top-start="relation.sap">{{relation.sap}}</i>
			</p>
		</td>
		<td class="customer-cell">
			<p class="left-td">
				<i v-tooltip="relation.customerName">{{relation.customerName | truncate}}</i>
			</p>
		</td>
		<td class="project-cell">
			<p class="left-td">
				<i v-tooltip="relation.projectTitle">{{relation.projectTitle | truncate}}</i>
			</p>
		</td>
		<td class="level-cell">
			<p class="left-td">
				<i v-tooltip.top-start="relation.levels">{{relation.levels | truncate}}</i>
			</p>
		</td>
		<td class="start-cell">
			<p class="left-td">
				<i
					v-tooltip.top-start="$options.filters.iso_to_date(relation.startDate)"
				>{{relation.startDate|iso_to_date|truncate}}</i>
			</p>
		</td>
		<td class="end-cell">
			<p class="left-td">
				<i
					v-tooltip.top-start="$options.filters.iso_to_date(relation.endDate)"
				>{{relation.endDate|iso_to_date|truncate}}</i>
			</p>
		</td>
		<td class="engag-cell">
			<p class="left-td">
				<!-- <vs-input size="small" class="table-input-x" v-model="value" @keyup="submitEngagement"/> -->
				<input
					class="table-input-x"
					v-model="engagement"
					@keyup="submitEngagement"
					:class="{'error-border':!isValid}"
				/>
				<!-- use `filled` class for filled style -->
			</p>
		</td>
		<td class="rate-cell">
			<p class="left-td">
			<!--	<i v-tooltip.top-start="relation.hourlyRate">{{relation.hourlyRate + ' €'}}</i> -->
			<i v-tooltip.top-start="roundedHourlyRate">{{ roundedHourlyRate + ' €' }}</i>
			</p>
		</td>
		<td class="left-days-cell">
			<p class="left-td left-days-cell-i" :class="daysLeftClass">{{relation.daysLeft}}</p>
		</td>
	</tr>
</template>

<script>
import filters from "../../../../mixins/filters";
import _ from "lodash";

export default {
  name: "RelationRow",
  props: ["relation", "index"],
  mixins: [filters],
  data: () => {
    return {
      typingTimer: 0,
      isValid: true,
      engagement: 0
    };
  },
  computed: {
    /**
     * Get the forecast metadata from store
     */
    metadata: function() {
      return this.$store.state.forecast.metadata;
    },
    /**
     * Find the class for days left field
     * Compare the meta data with the days left value
     */
    daysLeftClass: function() {
      let metadata = this.metadata;
      if (
        parseInt(this.relation.daysLeft) >=
        parseInt(metadata.employeeReportGreen)
      ) {
        return "green";
      } else if (
        parseInt(this.relation.daysLeft) >=
          parseInt(metadata.employeeReportRed) &&
        parseInt(this.relation.daysLeft) <
          parseInt(metadata.employeeReportGreen)
      ) {
        return "yellow";
      } else {
        return "red";
      }
    },
    isClosed:function(){
      if(this.relation.isClosed===true)
        return "closed-project-row"
      else
      return"open-project-row"
    },
	roundedHourlyRate: function() {
  if (this.relation.hourlyRate !== null && this.relation.hourlyRate !== undefined) {
    let roundedRate = Math.round(this.relation.hourlyRate * 100);
    return roundedRate / 100;
  } else {
    return null; 
  }
  }
  },
  methods: {
    /**
     * Submit the value changed after key up
     */
    submitEngagement: function() {
      // clear the timeout value
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (this.validate()) {
          // get the current relation
          let relation = _.cloneDeep(this.relation);
          // update the engagement value
          relation.projectEngagement = this.engagement;
          // generate the data object with the index and value
          let data = { id: this.index, value: relation };
          // update the field
          this.$store.dispatch("updateRelation", data);
        }
      }, 500);
    },
    /**
     * Validate the engagement input field
     * The value must be number less than 100
     * @returns {boolean}
     */
    validate: function() {
      let value = this.engagement;
      let RE = /^-{0,1}\d*\.{0,1}\d+$/;
      if (RE.test(value) && value <= 100 && value > 0) {
        this.isValid = true;
        return true;
      }
      this.isValid = false;
      return false;
    }
  },
  watch: {
    relation: {
      handler: function() {
        // init the relation engagement value
        this.engagement = this.relation.projectEngagement;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
	.error-border {
		border: 1px solid red;
	}

	.left-days-cell-i.green {
		background: #94e5dd;
		color: #099a8a;
	}

	.master-table-head-box .consulatant-cell {
		min-width: 197px;
		width: 197px;
		max-width: 197px;
	}
	
	
	.master-table .consulatant-cell {
		max-width: 197px;
		width: 197px;
		max-width: 197px;
	}

	.master-table .rate-cell {
		min-width: 82px;
		width: 82px;
		max-width: 82px;
	}

	.consulatant-cell .left-td {
		max-width: 110px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		vertical-align: middle;
	}
	tr.closed-project-row {
		background: #fc5c6575;
	}
	
	
		
	

</style>
